import { utilsModule } from "../utils-module";

utilsModule.factory('parameterService', ['$q','serverAddress', '$http',($q, serverAddress, $http) => {
    return {
        getParameterValue: function (parameterId) {
            return $q((resolve, reject) => {
                $http.get(serverAddress.nodeURL + '/Parametros/' + parameterId).then((res) => {
                    resolve(res.data.valor);
                }).catch((res) => {
                    reject(res.data.error);
                });
            });

        },

        getDefaultOrderBlock: function(orderTypeId){
            return $q((resolve, reject) => {
                $http.post(serverAddress.nodeURL + '/Parametros/getDefaultOrderBlock',{orderType:orderTypeId})
                .then((res) => {
                    resolve(res.data.data);
                }).catch((err) => {
                    reject(err);
                });
            });
        }
    }
}]);